import { AnyAction, combineReducers, Reducer } from 'redux';
import { AppState } from 'acscp/store/appState';

type ReducerMap = {
    [SubStateKey in keyof AppState]: Reducer<AppState[SubStateKey]>;
};

/**
 * Better typed version of combineReducer function configured to create the root AppState reducer.
 */
function createRootReducer(reducers: ReducerMap): Reducer<AppState> {
    return combineReducers<AppState>(reducers);
}

import { accountLinksReducer } from './accountLinksReducer';
import { authReducer } from './authReducer';
import { airportsReducer } from './airportsReducer';
import { bookingsReadDetailsReducer } from './bookingsReadDetailsReducer';
import { bookingsReducer } from './bookingsReducer';
import { brokerDetailsReducer } from './brokerDetailsReducer';
import { customerContactDetailsReducer } from './customerContactDetailsReducer';
import { itineraryReducer } from './itineraryReducer';
import { intlReducer } from './intlReducer';
import { loyaltyTermsAndConditionsMetaDataReducer } from './loyaltyTermsAndConditionsMetaDataReducer';
import { loyaltyTransactionsReducer } from './loyaltyTransactionsReducer';
import { menuReducer } from './menuReducer';
import { quotesReducer } from './quotesReducer';
import { networkReducer } from './networkReducer';
import { requestsReducer } from './requestStatusReducer';
import { notificationReducer } from './notificationReducer';
import { sharingDataReducer } from './sharingDataReducer';
import { giftsReducer } from './giftsReducer';
import { countriesReducer } from './countriesReducer';
import { previousEmailsReducer } from './previousEmailsReducer';
import { accountNotificationReducer } from './accountNotificationReducer';
import { bookingModificationRequestsReducer } from './bookingModificationRequestsReducer';
import { appVersionReducer } from './appVersionReducer';
import { createAccountReducer } from 'acscp/reducers/createAccountReducer';
import { pushNotificationsReducer } from 'acscp/reducers/pushNotificationsReducer';
import { storeStatusReducer } from './storeStatusReducer';

export const rootReducer = createRootReducer({
    accountLinks: accountLinksReducer,
    accountNotifications: accountNotificationReducer,
    airports: airportsReducer,
    appVersion: appVersionReducer,
    auth: authReducer,
    bookingsReadDetails: bookingsReadDetailsReducer,
    bookingsDetails: bookingsReducer,
    bookingModificationRequests: bookingModificationRequestsReducer,
    createAccountResponse: createAccountReducer,
    customerContact: customerContactDetailsReducer,
    menu: menuReducer,
    intl: intlReducer,
    loyaltyTermsAndConditionsMetaData: loyaltyTermsAndConditionsMetaDataReducer,
    loyaltyTransactions: loyaltyTransactionsReducer,
    broker: brokerDetailsReducer,
    quotes: quotesReducer,
    itineraries: itineraryReducer,
    network: networkReducer,
    requests: requestsReducer,
    notifications: notificationReducer,
    sharingData: sharingDataReducer,
    previousEmails: previousEmailsReducer,
    pushNotifications: pushNotificationsReducer,
    gifts: giftsReducer,
    countries: countriesReducer,
    storeStatus: storeStatusReducer,
});
